import React from 'react';
import { Modal, ModalProps } from 'react-bootstrap';

export default class ModalPreset extends React.Component<ModalProps, {}> {
    render() {
        return (
            <Modal size={undefined} centered {...this.props}>
                {this.props.children}
            </Modal>
        );
    }
}
